import { createMuiTheme } from '@material-ui/core/styles';
import fontSizes from './fontSizes';

//Layout
const spacing = 10;

export default createMuiTheme({
  spacing,
  fontSizes,
  borderRadius: 4,
  overrides: {
    MuiCardHeader: {
      root: {
        padding: `${spacing * .4}px ${spacing * 1.6}px`,
      },
      title: {
        fontWeight: 'normal',
        fontSize: '1rem',
      },
      action: {
        marginTop: -3,
      }
    },
    MuiCardContent: {
      root: {
        padding: spacing,
        '&:last-child': {
          paddingBottom: spacing,
        },
      },
    },
    MuiCardActions: {
      root: {
        justifyContent: 'flex-end',
      },
    },
    MuiButton: {
      label: {
        textTransform: 'capitalize',
      }
    },
  },
});
